<template>
        <div class="ajax-processing-spinner hide-spinner" v-show="showSpinner" :class="{'show-spinner': showSpinner}">
            <i class="fa fa-spinner"></i>
            <p>Processing</p>
        </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex';

    export default {
        name: 'Feed',

        computed: {
            ...mapState([
                'showSpinner'
            ])
        }
    }
</script>